import { atom } from "jotai";
import { isViewOnlyModeAtom } from "../permissions";

export const streamingProgressAtom = atom<number>(0);
streamingProgressAtom.debugLabel = "streamingProgressAtom";

export const hasStreamingProgressStartedAtom = atom(
  (get) => get(streamingProgressAtom) > 0,
);
hasStreamingProgressStartedAtom.debugLabel = "hasStreamingProgressStartedAtom";

export const startStreamingProgressSetter = atom(null, (get, set) => {
  const currentProgress = get(streamingProgressAtom);
  // Only start if progress is 0
  if (currentProgress > 0) return;
  set(isViewOnlyModeAtom, true); // Ensures we don't allow the user to edit the canvas when streaming is in progress
  set(streamingProgressAtom, 5);

  // Create random progress updates over 30 seconds
  const interval = setInterval(() => {
    set(streamingProgressAtom, (current) => {
      // If progress is 100 or 0, clear intervals and stop
      if (current >= 100 || current === 0) {
        clearInterval(interval);
        clearTimeout(finalTimer);
        return current;
      }

      const increment = 0.1;

      // Don't exceed 90% during the random updates
      return Math.min(95, current + increment);
    });
  }, 33);

  // Final animation to 100% after 30 seconds
  const finalTimer = setTimeout(() => {
    set(streamingProgressAtom, 95);
    clearInterval(interval);
  }, 30000);
});
startStreamingProgressSetter.debugLabel = "startStreamingProgressSetter";
